import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, ReplaySubject } from "rxjs";

@Injectable()
export class ProductService {
  productDataObservable$ = new ReplaySubject(1);

  private environments = {
    // add your local environment in this array to test on local network devices

    "http://localhost:4200": "https://stg-api.nvidia.partners",
    "https://dev-store.nvidia.com": "https://api.nvidia.partners",
    "https://stg-store.nvidia.com": "https://api.nvidia.partners",
    "https://store.nvidia.com": "https://api.nvidia.partners",
  };
  private headerEnvironments = {
    // add your local environment in this array to test on local network devices

    "http://localhost:4200": "http://www.nvidia.com",
    "https://shop.nvidia.com": "https://www.nvidia.com",
    "https://dev-shop.nvidia.com": "https://dev-shop.nvidia.com",
    "https://stg-shop.nvidia.com": "https://stg-shop.nvidia.com",
    "https://preview.nvidia.com": "https://preview.nvidia.com",
    "https://store.nvidia.com": "https://www.nvidia.com",
    "https://dev-store.nvidia.com": "https://dev-store.nvidia.com",
    "https://stg-store.nvidia.com": "https://stg-store.nvidia.com",
  };
  private currentEnvironment;
  private currentHeaderEnvironment;
  private origin;

  constructor(private http: HttpClient) {
    this.origin = window.location.origin;
    if (!this.environments.hasOwnProperty(this.origin)) {
      console.log(
        "Your environment is new, not in the environments object, so it can be added."
      );
      this.environments[this.origin] = "https://www.nvidia.com";
      this.headerEnvironments[this.origin] = "https://www.nvidia.com";
    } else {
      console.log("Your environment was found in environments.");
    }
    for (var i in this.environments) {
      if (i === this.origin) {
        this.currentEnvironment = this.environments[i];
      }
    }
    //  this.headerEnvironments[this.origin] = this.origin;
    for (var i in this.headerEnvironments) {
      if (i === this.origin) {
        this.currentHeaderEnvironment = this.headerEnvironments[i];
      }
    }
  }
  private responseFieldsArr = [
    "productVariationName",
    "imageUrl",
    "currencyCode",
    "mrp",
    "salePrice",
    "currencyCode",
    "screenDisplayType",
    "cpuProcessor",
    "dimensions",
    "sysMemorySize",
    "screenSize",
    "hdStorageSize",
    "hdStorageType",
    "hdStorageDesc",
    "screenDimension",
    "description",
    "languageCode",
    "locale",
    "isFeatured",
    "productName",
    "offerText",
    "status",
    "upc",
    "productId",
    "sku",
    "statusName",
    "sysMemoryType",
    "stsOfferTxt",
    "offerText",
    "hasStsOffer",
  ];
  private filtersArr = [
    {
      key: "distinctCategory",
      field: "displayName",
      isKeyword: true,
      // "order": "asc"
    },

    {
      key: "distinctGroupFamily",
      field: "groupType",
      isKeyword: true,
      filters: [
        {
          key: "distinctProductFamilyName",
          field: "productFamilyName",
          isKeyword: true,
          order: "desc",
        },
      ],
    },
    {
      key: "distinctManufacturer",
      field: "manufacturerName",
      isKeyword: true,
      order: "asc",
    },
    {
      key: "distinctMaxQSize",
      field: "maxQ",
      isKeyword: false,
    },
    {
      key: "distinctScreenSize",
      field: "screenDimension",
      isKeyword: false,
      order: "desc",
    },
    {
      key: "distinctVram",
      field: "vram",
      isKeyword: false,
      order: "asc",
    },
  ];
  getFilterDefaultObject(queryParams) {
    let persona = {
      personaType: queryParams.personaType,
    };
    let maxQObj = {
      maxQ: queryParams.max_q,
    };

    let obj = [
      {
        isKeyword: true,
        languageCode: queryParams.locale.toUpperCase() || "EN-US",
      },
      {
        should: [
          {
            displayName: "Desktop",
            isKeyword: false,
          },
          {
            displayName: "Studio Laptop",
            isKeyword: false,
          },
          {
            displayName: "MOBILE WORKSTATION",
            isKeyword: false,
          },
          {
            displayName: "Desktop Workstation",
            isKeyword: false,
          },
        ],
        minimum_should_match: 1,
      },
      {
        range: {
          salePrice: {
            gt: 99,
          },
        },
      },
      // {"statusKey": "check_availability"}
    ];
    let new_obj = [];
    if (queryParams.personaType) {
      persona.personaType = persona.personaType.replace(/"/g, "");
      if (new_obj.length > 0) {
        new_obj = [new_obj, persona];
      } else {
        new_obj = [persona];
      }
    }
    if (queryParams.max_q) {
      if (new_obj.length > 0) {
        new_obj = [new_obj, maxQObj];
      } else {
        new_obj = [maxQObj];
      }
    }
    if (new_obj.length > 0) {
      return [...obj, ...new_obj];
    } else {
      return [...obj];
    }
  }

  getProductFilters(
    queryParams,
    productFilters,
    forceRefresh?: boolean,
    loadDefault?: boolean
  ) {
    let newfilters = [];
    let filters = this.getFilterDefaultObject(queryParams);
    if (queryParams.category && !loadDefault) {
      newfilters.push({
        displayName: queryParams.category,
        isKeyword: true,
      });
    }
    let finalmust = null;
    if (newfilters.length > 0) {
      finalmust = [...filters, ...newfilters];
    } else {
      finalmust = [...filters];
    }
    const reqeustBody = {
      from: 0,
      size: 9,
      products: {
        musts: [...filters, ...newfilters],
        tokens: {
          isStsPdp: 1,
          isActive: 1,
          isDeleted: 0,
          // availability: 1,
          // isFeatured: 0,
        },
        sort: {
          isFeatured: "asc",
          isFounderEdition: "asc",
          salePrice: queryParams.sorting == "hp" ? "desc" : "asc",
        },
      },
      filters: this.filtersArr,
      responseFields: this.responseFieldsArr,
    };

    const categoriesQuery = {
      from: 0,
      size: 1,
      products: {
        musts: filters,
        tokens: {
          availability: 1,
          isStsPdp: 1,
          isActive: 1,
          isDeleted: 0,
        },
        sort: {
          salePrice: queryParams.sorting == "hp" ? "desc" : "asc",
        },
      },
      filters: [
        {
          key: "distinctCategory",
          field: "displayName",
          isKeyword: true,
        },
      ],
      responseFields: ["productVariationName"],
    };
    const mquery = {
      msearch: true,
      searches:
        queryParams.isCategoriesSuperset &&
        queryParams.isCategoriesSuperset.length == 0
          ? [reqeustBody, categoriesQuery]
          : [reqeustBody],
    };

    var resp = this.http
      .post(
        this.environments[this.origin] + "/products/v3/search",
        queryParams.isCategoriesSuperset &&
          queryParams.isCategoriesSuperset.length == 0
          ? mquery
          : reqeustBody
      )
      .pipe(
        map((response: any) => {
          const myObjStr = JSON.parse(response);
          myObjStr["queryParams"] = {
            ...queryParams,
            loadDefault: loadDefault,
          };
          response = myObjStr;
          response["productSearchCriteria"] = queryParams;

          return response;
        })
      );
    return resp;
  }

  getProduct(
    queryParams,
    forceRefresh?: boolean,
    initialFilterValues?: any
  ): Observable<any> {
    const params: HttpParams = new HttpParams();
    for (let i in queryParams) {
      if (queryParams[i]) {
        params.set(i, queryParams[i]);
      }
    }
    let requestOptions = { params: params };

    let filters = this.getFilterDefaultObject(queryParams);
    let newfilters = [];
    let newfilters2 = [];
    if (queryParams.search) {
      newfilters = [
        ...filters,
        {
          productVariationName: {
            analyzer: "standard",
            query: queryParams.search || "",
          },
        },
      ];
    }
    if (queryParams.category) {
      newfilters = [
        ...filters,
        ...newfilters,
        {
          //  must:{
          displayName: queryParams.category,
          isKeyword: true,
          //  },
          // minimum_should_match: 1,
        },
      ];
      newfilters2 = [
        ...filters,
        {
          displayName: queryParams.category,
          isKeyword: true,
        },
      ];
    }
    if (queryParams.manufacturer) {
      let manufacturerArr = queryParams.manufacturer
        .split(",")
        .map((manufacturer) => {
          return {
            manufacturerName: manufacturer,
            isKeyword: true,
          };
        });
      let manufacturerObj = {
        should: [...manufacturerArr],
        minimum_should_match: 1,
      };
      newfilters = [...filters, ...newfilters, manufacturerObj];
    }

    if (
      queryParams.screen_size &&
      (!queryParams.category ||
        (queryParams.category !== "Desktop Workstation" &&
          queryParams.category !== "Desktop"))
    ) {
      let screenSizeArr = queryParams.screen_size.split(",").map((size) => {
        return {
          screenDimension: size.replace('"', ""),
        };
      });
      let screenSizeArrObj = {
        should: [...screenSizeArr],
        minimum_should_match: 1,
      };
      newfilters = [...filters, ...newfilters, screenSizeArrObj];
    }

    if (queryParams.gpu) {
      let sizeArr = [];
     
      if (
        queryParams.gpu.includes("geforce") ||
        queryParams.gpu.includes("quadro") ||
        queryParams.gpu.includes("nvrtx")
      ) {
        if (queryParams.gpu.includes("geforce")) {
          sizeArr.push("geforce");
        }
        if (queryParams.gpu.includes("quadro")) {
          sizeArr.push("quadro");
        }
        if (queryParams.gpu.includes("nvrtx")) {
          sizeArr.push("nvrtx");
        }
        let superGpuFilter = [
          {
            groupType: sizeArr.join(),
          },
        ];
        let gpuObj = {
          should: [...superGpuFilter],
          minimum_should_match: 1,
        };
        newfilters = [...filters, ...newfilters, gpuObj];
      } else {
        debugger;
        let sizeArr2 = queryParams.gpu.split(",").map((gpu) => {
          if (gpu !== "quadro" && gpu !== "geforce" && gpu !== "nvrtx") {
            return {
              productFamilyName: gpu,
              isKeyword: true,
            };
          }
        });
        let gpuObj = {
          should: [...sizeArr2],
          minimum_should_match: 1,
        };
        newfilters = [...filters, ...newfilters, gpuObj];
      }
    }
    var vramFilter = {};
    if (queryParams.vram) {
      let sizeArr = queryParams.vram.split(",");
      vramFilter = {
        range: {
          vram: {
            gte: parseInt(sizeArr[0]),
            lte: parseInt(sizeArr[1]),
          },
        },
      };
    }

    const mquery = {
      msearch: true,
      searches: [
        {
          from: queryParams.page ? (queryParams.page - 1) * 10 : 0,
          size: 10,
          products: {
            musts: newfilters2 && newfilters2.length ? newfilters2 : filters,
            // musts:[{groupType: "quadro,nvrtx"}],
            tokens: {
              isStsPdp: 1,
              isActive: 1,
              isDeleted: 0,
              // "isFeatured": 0,
              availability: 1,
            },
            sort: {
              salePrice: queryParams.sorting == "hp" ? "desc" : "asc",
            },
            ...vramFilter,
          },
          filters: [...this.filtersArr],
          responseFields: this.responseFieldsArr,
        },
        {
          from: queryParams.page ? (queryParams.page - 1) * 10 : 0,
          size: 10,
          products: {
            musts: newfilters.length
              ? Array.from(new Set(newfilters))
              : filters,
            // musts:[{groupType: "quadro,nvrtx"}],
            tokens: {
              isStsPdp: 1,
              isActive: 1,
              isDeleted: 0,
              // "isFeatured": 0,
              availability: 1,
            },
            sort: {
              salePrice: queryParams.sorting == "hp" ? "desc" : "asc",
            },
            ...vramFilter,
          },
          filters: [
            ...this.filtersArr,
            {
              key: "totalCount",
              field: "isStsPdp",
              isKeyword: false,
            },
          ],
          responseFields: this.responseFieldsArr,
        },
        {
          from: 0,
          size: 3,
          products: {
            musts: newfilters.length
              ? Array.from(new Set(newfilters))
              : filters,
            tokens: {
              isStsPdp: 1,
              isActive: 1,
              isDeleted: 0,
              availability: 1,
              isFeatured: 1,
              // "languageCode": "EN-US"
            },
            sort: {
              salePrice: queryParams.sorting == "hp" ? "desc" : "asc",
            },
          },
          filters: this.filtersArr,
          responseFields: this.responseFieldsArr,
        },
      ],
    };

    var resp = this.http
      .post(this.environments[this.origin] + "/products/v3/search", mquery, {})
      .pipe(
        map((response: any) => {
          const _sort = [
            { displayName: "lowest_price", value: "lp", selected: false },
            { displayName: "highest_price", value: "hp", selected: false },
          ];
          const myObjStr = response;

          if (queryParams.sorting == "hp") {
            _sort[1].selected = true;
          } else {
            _sort[0].selected = true;
          }
          myObjStr["sort"] = _sort;
          myObjStr["queryParams"] = queryParams;
          response = myObjStr;
          return response;
        })
      );

    return resp;
  }

  getRetailInfo(upcCode) {
    return this.http
      .get(this.currentEnvironment + `/edge/product/${upcCode}/retailer/info`)
      .pipe(map((res) => res));
  }

  getHeaderData(locale) {
    let region = locale.substr(3);
    let reformattedLocale = locale.substring(0, 2) + "_" + region.toUpperCase();
    // return this.http.get(`https://wwwstage.nvidia.com/bin/service/nvHeaderFooterSrvc?locale=${reformattedLocale}&region=${region}&brand=geforce`)
    // return this.http.get(this.currentEnvironment + `/bin/service/nvHeaderFooterSrvc?locale=${reformattedLocale}&region=${region}&brand=geforce`);

    let borrowShieldHeaderData = false;
    if (
      borrowShieldHeaderData &&
      /10.110|localhost|wwwdev/.test(window.location.href)
    ) {
      console.log(
        `in a test environment, borrowing Shield's header data to test hoveritemslvl2 until Geforce header has hoveritemslvl2`
      );
      return this.http.get(
        this.currentHeaderEnvironment +
          `/bin/service/nvHeaderFooterSrvc?locale=${reformattedLocale}&region=${region}&brand=shield`
      );
    } else {
      return this.http.get(
        this.currentHeaderEnvironment +
          `/bin/service/nvHeaderFooterSrvc?locale=${reformattedLocale}&region=${region}&brand=geforce`
      );
    }
  }
  currentEnv() {
    return this.currentEnvironment;
  }
}
